
export default {
    data() {
        return {
            type: '3',
            loginPhone: '',
            loginPassword: '',
            // isLoginMessage:false,
            // loginMessage:'',
        }
    },
    methods: {
        //后台管理的登录
        backLogin() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (!this.loginPhone.trim()) {
                this.$message.error('手机号不能为空');
            } else if (!reg.test(this.loginPhone)) {
                this.$message.error('手机号格式错误');
            } else if (!this.loginPassword.trim()) {
                this.$message.error('密码不能为空');
            } else if (this.type === '') {
                this.$message({
                    message: '请选择登录类型',
                    type: 'warning'
                });
            } else if (this.type !== '') {
                let obj = {
                    phone: this.loginPhone,
                    password: this.loginPassword,
                }
                this.$post('instructor/login', obj).then(res => {
                    if (res.data.status == 'success') {
                        // console.log('这个东西呀')
                        // console.log(res.data.result.token);
                        this.$store.state.instructor = res.data.result.token;
                        sessionStorage.setItem("instructor",this.$store.state.instructor);
                        this.$router.push({
                            path: '/Instructor',
                            // query: {
                            //     value: res.data.result.id
                            // }
                        });
                    } else {
                        this.$message.error('密码错误');
                    }

                })
            }
        }
    }
}
